angular.module('unica_notification.notification_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// NOTIFICATION
		.state('app.notification', {
			url: '/notification',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/notification/templates/notification.html',
					controller: 'NotificationBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})


			// NOTIFICATION LIST
			.state('app.notification.list', {
				url: '/list/:event_id',
				views: {
					'notificationContent': {
						templateUrl: './modules/notification/templates/list.html',
						controller: 'NotificationListController'
					}
				},
				ncyBreadcrumb: {
					label: 'Lista Notifiche',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
					}
				}
			})

			// NOTIFICATION CREATE
			.state('app.notification.create', {
				url: '/create/:event_id',
				views: {
					'notificationContent': {
						templateUrl: './modules/notification/templates/create.html',
						controller: 'NotificationCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Crea Notifica',
					parent: 'app.notification.list'
				}
			})

			// NOTIFICATION EDIT
			.state('app.notification.edit', {
				url: '/edit/:event_id/:id',
				views: {
					'notificationContent': {
						templateUrl: './modules/notification/templates/edit.html',
						controller: 'NotificationEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Notifica',
					parent: 'app.notification.list'
				}
			})

			// NOTIFICATION ASSIGN
			.state('app.notification.assign', {
				url: '/assign/:event_id/:id',
				views: {
					'notificationContent': {
						templateUrl: './modules/notification/templates/assign.html',
						controller: 'NotificationAssignController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Seleziona Invitati',
					parent: 'app.notification.list'
				}
			})
	;


});
